import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import { ModalData } from "../modal.service";

@Component({
    selector: "s25-ng-modal-edit-event-form-config",
    template: `
        @if (isInit) {
            <div class="s25-ng">
                <s25-modal-header [data]="data"></s25-modal-header>
                <div class="modal-body">
                    <s25-ng-event-form-config
                        [id]="data.id"
                        [mode]="data.mode"
                        (saved)="onSaved()"
                        (cancelled)="onCancelled()"
                    ></s25-ng-event-form-config>
                </div>
            </div>
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ModalEditEventFormConfigComponent implements OnInit {
    @Input() data: ModalData & {
        id?: number;
        mode?: "create" | "copy" | "edit";
        onSave?: VoidFunction;
        onCancel?: VoidFunction;
    };
    isInit: boolean = false;

    ngOnInit() {
        this.isInit = true;
    }

    onSaved() {
        this.data.closeModal();
        this.data.onSave?.();
    }

    onCancelled() {
        this.data.closeModal();
        this.data.onCancel?.();
    }
}
